import { QdeService } from "./../services/qde.service";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IwService } from "../services/iw.service";
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";
import { MatVerticalStepper } from "@angular/material/stepper";
import { SharedServiceService } from "./../services/shared-service.service";
// import { ISTATACARD, airindiaTheme, OLATheme, SBICARDTheme } from '../config/app-settings.config';
//import { ISTATACARD, ACCOUNT_NO_SBI, VALIDATION_MSG, SBICARDTheme } from '../config/app-settings.config';//Mine
import { ISTATACARD, ACCOUNT_NO_SBI, VALIDATION_MSG, SBICARDTheme, IS_CAMPAIGN } from '../config/app-settings.config';
import { WSCallDetailsData } from '../model/creat-update-lead';
import { ThemeService } from '../services/theme.service';
import cssVars from "css-vars-ponyfill";
import { PersistanceStorageService } from '../services/persistance-storage.service';
import { getCookie } from "../utilities/utilities.file";
import { MatDialog } from '@angular/material/dialog';
import { PopUpModalComponent } from './pop-up-modal/pop-up-modal.component';

declare var $: any;
declare var jQuery: any;
declare var form_abandon: Function;
declare var analytics: any;
type Params = {
  [key: string]: any;
};
@Component({
  selector: "app-qde",
  templateUrl: "./qde.component.html",
  styleUrls: ["./qde.component.scss"]
})
export class QdeComponent implements OnInit, AfterViewInit {
  _cardName: any;
  eapplyFormLabel: any;
  fcnExistingUser: FormControl;
  firstCompleted: any;
  @ViewChild("matVerticalStepper") stepper: MatVerticalStepper;

  cardDcrData: any;
  allPinList = [];
  appName: any;
  masterData: any;
  journey: boolean = false;
  firstStep: any;
  secondStep: any;
  existingUser: boolean = false;
  fromBanka: boolean = false;
  bancaForm: FormGroup;
  savingAccounts: any;
  housingLoans: any;
  carLoans: any;
  TATACARD = ISTATACARD;
  isBanca: any;
  dcrCardUrlMapping: any;
  routerparams: any;
  shortcampaign: any;
  resetSortcampaign: any;
  themeObj: any;
  analytics: any;

  // dataFromRetrivePopup: any;
  retrieveDataReceived: any;
  validationMsgs: any;
  acc_no_sbi: string;
  themeParam: any;
  responseTheme: any;
  // convertedjson: {};
  //enableBanca: boolean = true;
  channel: any;
  fetchName: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  path: any;
  channelName: string;
  isShortLeadNew: any;
  channelBanca: string;
  fromSwiftJourney: boolean;


  constructor(
    private qdeService: QdeService,
    private route: ActivatedRoute,
    private iw: IwService,
    private sharedService: SharedServiceService,
    private themeService: ThemeService,
    private fb: FormBuilder,
    private router: Router,
    private persistanceService: PersistanceStorageService,
    public dialog: MatDialog
  ) {
    this.partnerCode = this.themeService.partnerCode;
    this.xmlCall();
  }

  ngOnInit() {


    this.fromSwiftJourney = this.sharedService.fromSwiftJourney;

    if (this.partnerCode && this.containerType) {
      document.getElementById('sbicard') ? document.getElementById('sbicard').scrollTop = 0 : (document.documentElement || document.body).scrollTop = 0;
    } else {
      (document.documentElement || document.body).scrollTop = 0;
    }

    // this.route.queryParams.subscribe(query => {
    //   if(query.path && query.theme){
    //     const theme = query.theme;
    //     this.setThemeByParam(theme);
    //   }
    // });
    this.validationMsgs = VALIDATION_MSG;
    this.acc_no_sbi = ACCOUNT_NO_SBI
    this.createForm();
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.savingAccounts = this.iw.geteapplyBancaSavingAccountDCR();
    this.carLoans = this.iw.geteapplyBancaCarLoanDCR();
    this.housingLoans = this.iw.geteapplyBancaHousingLoanDCR();
    this.fcnExistingUser = new FormControl("N");
    this.isShortLeadNew = getCookie('isShortLeadNew');
    if (this.isShortLeadNew === 'true') {
      this.firstStep = true;
      //this.secondStep=true;
    }
    this.isBanca = this.sharedService.paramschannel == '901' ? true : false;
    this.retrieveJourney();
    // (document.documentElement || document.body).scrollTop = 0;
    document.getElementById('sbicard') ? document.getElementById('sbicard').scrollTop = 0 : (document.documentElement || document.body).scrollTop = 0;

    //Theming logic
    this.shortcampaign = this.route.snapshot.queryParams.ssl;
    this.sharedService.sslEnabled = (this.shortcampaign == 'true') ? true : false;
    console.log("Value of shortcampaign is " + this.shortcampaign);

    // this.themeService.routerParam = this.routerparams?this.routerparams:'sbicard';
    // console.log(this.routerparams); 
    // this.themeObj = this.getTheme(this.routerparams);
    // this.themeService.setThemePage(this.themeObj);
    // //Theme change for IE
    // cssVars({variables: this.themeObj});

    // if (this.isBanca == true) {
    //   this.enableBanca = true;
    // }
    // else {
    //   this.enableBanca = false;
    // }
    setTimeout(() => { this.callFormAbandon() }, 3600000);

    if (this.sharedService.trackApplicationResponse) {
      if(this.fromSwiftJourney){
        this.channelBanca = this.sharedService.trackApplicationResponse.data.channelCode;
      }
      else{
        this.channelBanca = this.sharedService.trackApplicationResponse.channelCode;
      }
      
    } else {
      this.channelBanca = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }
    //Analytics call for page load       
    if (window['analytics']) {
      analytics.track('eapply__page__application_page', {
        'PAGE_NAME': window["digitalData"].page.pageName,
        'PAGE_URL': window["digitalData"].page.PAGE_URL,
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
        'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
        'CHANNEL_NAME': this.sharedService.paramschannel,
        'JOURNEY_NAME': 'EAPPLY',
        'CARD_TYPE': this.cardDcrData.root.card_information.card_type,
      });
    }

  }


  receiveSslEnabledFlag($event) {
    this.resetSortcampaign = $event;
    console.log(this.resetSortcampaign);
  }

  // getTheme(id){
  //   if(id == 'airindia') {
  //     return airindiaTheme;
  //   } else if(id == 'ola'){
  //     return OLATheme;
  //   } else {
  //     return SBICARDTheme;
  //   }
  // }

  ngAfterViewInit() {

    // this.getMasterData();
    if (this.sharedService.paramschannel == '901') {
      window["digitalData"].page = { pageName: 'sbi-card:banca:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
    } else if (this.sharedService.paramsshortCode || sessionStorage.getItem('sc')) {
      window["digitalData"].page = { pageName: 'sbi-card:reapply:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:eapplyform', pageType: 'Eapply' };
    }
    window["digitalData"].decisionType = "";
    // window["digitalData"].instantDecision = "";
    window["digitalData"].eapply = { instantDecision: "" };
    window["digitalData"].application = { status: "Incomplete", number: "" };
    if (this.sharedService.cardName) {
      window["digitalData"].card = { cardName: this.sharedService.cardName };
    }
    if (this.isShortLeadNew === 'true') {
      this.stepper.next();
    }
  }

  createForm() {
    this.bancaForm = this.fb.group({
      fncSBIRelationship: [''],
      fcnAccountNo: [''],
      fcnHouseLoan: [''],
      fcnCarLoan: ['']
    })
  }

  get f() {
    return this.bancaForm.controls;
  }

  xmlCall() {
    this.route.queryParams.subscribe(query => {
      if (query) {
        this.isBanca = query.CHN && query.CHN == '901' ? true : false;
        this.channel = query.CHN ? query.CHN : null;
        this.sharedService.paramschannel = query.CHN;
        const urlPath = query.path;
        const partnerTheme = query.theme;
        if (urlPath) {
          this.getXml(urlPath, this.channel);
        }
        else if (partnerTheme) {
          this.getXml(this.themeService.partnerDcr, this.channel);
        } else if (this.containerType && this.partnerCode) {
          this.getXml(this.themeService.partnerDcr, this.channel);
        } else {
          this.getXml(this.themeService.partnerDcr, this.channel);
        }
      }
    });
  }

  getXml(urlPath, channel) {
    let getPathFromSession = this.persistanceService.getStorageWithExpiry('dcrPath', 'localstorage');
    if (getPathFromSession == urlPath) {
      this.cardDcrData = this.persistanceService.getStorageWithExpiry('convertedJson', 'localstorage');
      if (this.cardDcrData && this.cardDcrData.root && this.cardDcrData.root.card_information && this.cardDcrData.root.card_information.card_name) {
        this.sharedService.sbic_card_name = this.cardDcrData.root.card_information.card_name;
        this.sharedService.cardName = this.cardDcrData.root.card_information.card_name
        window["digitalData"].card = { cardName: this.cardDcrData.root.card_information.card_name };
      }
      this.sharedService.setDcr(this.cardDcrData);
      this.getMasterData(urlPath);
      this.patchRetrieveData();
    } else {
      let serviceCall = this.iw.getDcrXmlResponse(urlPath, channel);
      this.path = urlPath;
      serviceCall.subscribe((xml: any) => {
        if (xml) {
          let convertedjson = xml;
          ISTATACARD ? this.cardDcrData = convertedjson['root'] : this.cardDcrData = convertedjson;
          localStorage.setItem('convertedJson', JSON.stringify(this.cardDcrData));
          this.persistanceService.setStorageWithExpiry('convertedJson', this.cardDcrData, 'local', null);
          this.persistanceService.setStorageWithExpiry('dcrPath', this.path, 'local', null);
          // this.cardDcrData?this.getMasterData():true;
          if (this.cardDcrData && this.cardDcrData.root && this.cardDcrData.root.card_information && this.cardDcrData.root.card_information.card_name) {
            this.sharedService.sbic_card_name = this.cardDcrData.root.card_information.card_name;
            this.sharedService.cardName = this.cardDcrData.root.card_information.card_name
            window["digitalData"].card = { cardName: this.cardDcrData.root.card_information.card_name };
          }
          this.sharedService.setDcr(this.cardDcrData);
          this.getMasterData(this.path);
          this.patchRetrieveData();
        } else {
          // return this.router.navigate(['/error']);
        }
      }, error => {
        // return this.router.navigate(['/error']);
      });
    }

  }

  getMasterData(urlPath) {
    this.channelName = (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') ? "EALB" : ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') ? "EABP" : this.sharedService.fromSwiftJourney ? "SAPL" : "EAPL");
    let getPathFromSession = this.persistanceService.getStorageWithExpiry('dcrPath', 'localstorage');
    let channelNameFromSession = this.persistanceService.getStorageWithExpiry('channelName', 'localstorage');
    let masterResult = this.persistanceService.getStorageWithExpiry('masterResponse', 'localstorage');

    if (getPathFromSession == urlPath && masterResult && masterResult.eapplyMasterDataRsType &&
      ((this.channelName == 'EALB' && masterResult.eapplyMasterDataRsType.bancaCityList && masterResult && masterResult.eapplyMasterDataRsType.bancaCityList.length)
        || (this.channelName != 'EALB' && masterResult.eapplyMasterDataRsType.cityList && masterResult && masterResult.eapplyMasterDataRsType.cityList.length))) {
      if (masterResult.eapplyMasterDataRsType && masterResult.eapplyMasterDataRsType.statusCode === "000") {
        this.masterData = masterResult.eapplyMasterDataRsType;
        this.sharedService.autoPinCode = this.masterData;
      }

    } else {
      let requestBody: any;
      //Changes done for splitting the master service, only to call city or banca city on load
      requestBody = {
        cardType: this.cardDcrData.root.card_information.card_type,
        cardChannelCode: (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') ? "EALB" : ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') ? "EABP" : this.sharedService.fromSwiftJourney ? "SAPL" : "EAPL"),
        cityList: (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') ? "N" : "Y",
        // companyList: "Y",
        companyList: (this.sharedService.paramsfirstName && this.sharedService.paramsmobileNo) || this.sharedService.paramsshortCode ? "Y" : "N",
        bancaCityList: (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') ? "Y" : "N",
        // designationList: "Y"
        designationList: (this.sharedService.paramsfirstName && this.sharedService.paramsmobileNo) || this.sharedService.paramsshortCode ? "Y" : "N"
      };
      this.qdeService.fetchMatserData(requestBody).subscribe((result: any) => {
        if (result.eapplyMasterDataRsType && result.eapplyMasterDataRsType.statusCode === "000") {
          this.masterData = result.eapplyMasterDataRsType;
          this.sharedService.autoPinCode = this.masterData;
          let company: any;
          let designation: any;
          company = result.eapplyMasterDataRsType.companyList ? result.eapplyMasterDataRsType.companyList : null;
          designation = result.eapplyMasterDataRsType.designationList ? result.eapplyMasterDataRsType.designationList : null;
          this.sharedService.setCompDesig({ comp: company, desg: designation });
          let data: any = result;
          window['masterResponse'] = data;
          // sessionStorage.setItem('masterResponse', JSON.stringify(data));
          // this.persistanceService.setStorageWithExpiry('masterResponse',JSON.stringify(data),'local',null);
          this.persistanceService.setStorageWithExpiry('channelName', this.channelName, 'local', null);
        }
      }, err => {
        console.log('Service Error', err);
      }
      );
    }
  }

  selectJourney() {
    if (this.fcnExistingUser) {
      if (this.fcnExistingUser.value == "Y") {
        if (this.channelBanca === 'EALB' || this.TATACARD == true || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
          this.journey = true;
        } else {
          this.journey = false;
        }
      } else {
        this.journey = false;
      }
    }
  }

  selectedIndex($event) {
    if (this.stepper) {
      this.firstStep = $event.completed;
      setTimeout(() => (this.stepper.selectedIndex = $event.stepIndex), 1000);
    }
  }
  selectedIndex1($event) {
    if (this.stepper) {
      this.secondStep = $event.completed;
      setTimeout(() => (this.stepper.selectedIndex = $event.stepIndex), 1000);
    }
  }
  existingUserTrue() {
    if (this.channelBanca === 'EALB' || this.TATACARD == true || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
      this.existingUser = true;
      this.qdeService.existingUser = this.existingUser;
    } else {
      const dialogRef = this.dialog.open(PopUpModalComponent);
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed1', result);
        // if ( result == true) {
        console.log('The dialog was closed', result);
        // this.journey = false;
        this.existingUser = false;
        this.qdeService.existingUser = this.existingUser;
        this.fcnExistingUser = new FormControl("N");
        // } 
      });
    }

  }

  existingUserFalse() {
    this.existingUser = false;
    this.qdeService.existingUser = this.existingUser;
  }

  selectionChange(event) {
    if (!this.isBanca) {
      if (this.stepper.selectedIndex === 0) {
        setTimeout(() => {
          window.scrollTo(0, 230);
        }, 500);
      } else if (this.stepper.selectedIndex === 1) {
        setTimeout(() => {
          window.scrollTo(0, 290);
        }, 500);
      } else if (this.stepper.selectedIndex === 2) {
        setTimeout(() => {
          window.scrollTo(0, 350);
        }, 500);
      }
      // setTimeout(() => (this.stepper.selectedIndex === 0 ? window.scrollTo(0, 230) : window.scrollTo(0, 0)), 500);
      // setTimeout(() => (this.stepper.selectedIndex === 1 ? window.scrollTo(0, 290) : window.scrollTo(0, 0)), 500);
      // setTimeout(() => (this.stepper.selectedIndex === 2 ? window.scrollTo(0, 350) : window.scrollTo(0, 0)), 500);
    } else {
      if (this.stepper.selectedIndex === 0) {
        setTimeout(() => {
          window.scrollTo(0, 470);
        }, 500);
      } else if (this.stepper.selectedIndex === 1) {
        setTimeout(() => {
          window.scrollTo(0, 530);
        }, 500);
      } else if (this.stepper.selectedIndex === 2) {
        setTimeout(() => {
          window.scrollTo(0, 590);
        }, 500);
      }
      // setTimeout(() => (this.stepper.selectedIndex === 0 ? window.scrollTo(0, 470) : window.scrollTo(0, 0)), 500);
      // setTimeout(() => (this.stepper.selectedIndex === 1 ? window.scrollTo(0, 530) : window.scrollTo(0, 0)), 500);
      // setTimeout(() => (this.stepper.selectedIndex === 2 ? window.scrollTo(0, 590) : window.scrollTo(0, 0)), 500);
    }
  }
  retrieveJourney() {
    if (this.sharedService.retrievedApplicationResponse) {                                   ////==========================> Change for swift redirection
      this.dcrCardUrlMapping = this.iw.geteapplyCardUpgradeMappingDCR();
      if(this.fromSwiftJourney){
        const dcrPath = this.dcrCardUrlMapping.find(item => (item.key_name == (this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.cardType))).key_value
        this.getXml(dcrPath, this.channel);
      }
      else{
        const dcrPath = this.dcrCardUrlMapping.find(item => (item.key_name == (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardType))).key_value
        this.getXml(dcrPath, this.channel);
      }
      
    }
  }

  patchRetrieveData() {
    if (this.sharedService.retrievedApplicationResponse) {
      if (this.fromSwiftJourney) {
        let wsDetails = new WSCallDetailsData();
        let wsDetails1 = new WSCallDetailsData();
        let gem1 = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.gemId1 ? this.sharedService.retrievedApplicationResponse.data.gemId1 : '';
        let gem2 = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.gemId2 ? this.sharedService.retrievedApplicationResponse.data.gemId2 : '';
        // let gem1 = '';
        // let gem2 = '';
        wsDetails.WSCallUserGender = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.gender ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.gender : null
        wsDetails.WSCallUserSalutation = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.salutation ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.salutation : null;
        wsDetails.WSCallUserFirstName = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.firstName ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.firstName : null;
        // wsDetails.WSCallUserMiddleName = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.WSCallUserMiddleName ? this.sharedService.retrievedApplicationResponse.data.WSCallUserMiddleName : null;
        wsDetails.WSCallUserMiddleName = null;
        wsDetails.WSCallUserLastName = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.lastName ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.lastName : null;
        wsDetails.WSCallUserCity = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.contactDetails.resiCity ? this.sharedService.retrievedApplicationResponse.data.contactDetails.resiCity : null;
        wsDetails.WSCallUserMobileNumber = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.mobileNumber : null;
        wsDetails.WSCallUserEmailId = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.personalEmailId : null;
        wsDetails.WSCallUserContactConsent = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.consentGiven ? this.sharedService.retrievedApplicationResponse.data.consentGiven : null;
        // wsDetails.WSCallCardReferralCode = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.WSCallCardReferralCode ? this.sharedService.retrievedApplicationResponse.data.WSCallCardReferralCode : null;
        wsDetails.WSCallCardReferralCode = null;
        wsDetails.WSCallCardType = this.cardDcrData ? this.cardDcrData.root.card_information.card_type : null;
        wsDetails.WSCallCardCategory = this.cardDcrData ? this.cardDcrData.root.card_information.card_category : null;
        wsDetails.WSCallGemId1 = this.sharedService.paramsshortCode ? 'C2B_' + gem1 : gem1;
        wsDetails.WSCallGemId2 = this.sharedService.paramsshortCode ? 'C2B_' + gem2 : gem2;
        wsDetails.WSCallSourceCode = IS_CAMPAIGN ? 'DC' : 'WEBS';
        wsDetails.WSCallChannelCode = this.isBanca ? 'EALB' : ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') ? "EABP" : this.sharedService.fromSwiftJourney ? "SAPL" : "EAPL");
        wsDetails.WSCallDomainName = 'sbicard';
        wsDetails.WSCallAppSourceCode = this.sharedService.sourceCode;
        wsDetails.WSCallApplicationSource = this.sharedService.promoGroup;
        wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';


        this.qdeService.aboutData = wsDetails;
        wsDetails1.WSCallUserDesignation = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation : null;
        wsDetails1.WSCallUserCompany = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName : null;
        wsDetails1.WSCallUserOfficePincode = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.officeAddress && this.sharedService.retrievedApplicationResponse.data.officeAddress.offPinCode ? this.sharedService.retrievedApplicationResponse.data.officeAddress.offPinCode : null;
        wsDetails1.WSCallUserPanNumber = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan : null;
        wsDetails1.WSCallUserOccupationCode = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType : null;
        wsDetails1.WSCallUserAnnualIncomeValue = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.incomePa ? this.sharedService.retrievedApplicationResponse.data.incomePa : null;
        wsDetails1.WSCallUserDOB = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth : null;
        this.qdeService.professionalData = wsDetails1;
        this.qdeService.secondSectionData = Object.assign(
          {},
          wsDetails, wsDetails1
        );
        this.fetchName = this.sharedService.retrievedApplicationResponse.data && this.sharedService.retrievedApplicationResponse.data.applicantDetails.firstName ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.firstName + ',' : '';

        if (this.sharedService.retrievedApplicationResponse.data
          && (this.sharedService.retrievedApplicationResponse.data.applicantDetails.salutation != 1 && this.sharedService.retrievedApplicationResponse.data.applicantDetails.salutation != 2)) {
          this.firstStep = false;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 0), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.data
          && (this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType == 'P' || this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType == 'T')
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth
        ) {
          this.secondStep = true;
          this.firstStep = true;
          setTimeout(() => (this.stepper.selectedIndex = 2), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.data
          && (this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType != 'P' && this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType !== 'T')
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth
          && this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName
          && this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation
          && this.sharedService.retrievedApplicationResponse.data.incomePa
          && this.sharedService.retrievedApplicationResponse.data.officeAddress.offPinCode
        ) {
          this.secondStep = true;
          this.firstStep = true;
          setTimeout(() => (this.stepper.selectedIndex = 2), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.data
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.mobileNumber
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.salutation
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.firstName
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.lastName
          && this.sharedService.retrievedApplicationResponse.data.contactDetails.resiCity
          && this.sharedService.retrievedApplicationResponse.data.applicantDetails.personalEmailId
          && this.sharedService.retrievedApplicationResponse.data.consentGiven
        ) {
          this.firstStep = true;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 1), 1000);
        } else {
          this.firstStep = false;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 0), 1000);
        }
      }
      else {
        let wsDetails = new WSCallDetailsData();
        let wsDetails1 = new WSCallDetailsData();
        let gem1 = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1 ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1 : '';
        let gem2 = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 : '';
        wsDetails.WSCallUserGender = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserGender ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserGender : null
        wsDetails.WSCallUserSalutation = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation : null;
        wsDetails.WSCallUserFirstName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName : null;
        wsDetails.WSCallUserMiddleName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName : null;
        wsDetails.WSCallUserLastName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName : null;
        wsDetails.WSCallUserCity = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity : null;
        wsDetails.WSCallUserMobileNumber = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber : null;
        wsDetails.WSCallUserEmailId = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId : null;
        wsDetails.WSCallUserContactConsent = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserContactConsent ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserContactConsent : null;
        wsDetails.WSCallCardReferralCode = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode : null;
        wsDetails.WSCallCardType = this.cardDcrData ? this.cardDcrData.root.card_information.card_type : null;
        wsDetails.WSCallCardCategory = this.cardDcrData ? this.cardDcrData.root.card_information.card_category : null;
        wsDetails.WSCallGemId1 = this.sharedService.paramsshortCode ? 'C2B_' + gem1 : gem1;
        wsDetails.WSCallGemId2 = this.sharedService.paramsshortCode ? 'C2B_' + gem2 : gem2;
        wsDetails.WSCallSourceCode = IS_CAMPAIGN ? 'DC' : 'WEBS';
        wsDetails.WSCallChannelCode = this.isBanca ? 'EALB' : ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') ? "EABP" : this.sharedService.fromSwiftJourney ? "SAPL" : "EAPL");
        wsDetails.WSCallDomainName = 'sbicard';
        wsDetails.WSCallAppSourceCode = this.sharedService.sourceCode;
        wsDetails.WSCallApplicationSource = this.sharedService.promoGroup;
        wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';


        this.qdeService.aboutData = wsDetails;
        wsDetails1.WSCallUserDesignation = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation : null;
        wsDetails1.WSCallUserCompany = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany : null;
        wsDetails1.WSCallUserOfficePincode = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode : null;
        wsDetails1.WSCallUserPanNumber = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber : null;
        wsDetails1.WSCallUserOccupationCode = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode : null;
        wsDetails1.WSCallUserAnnualIncomeValue = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue : null;
        wsDetails1.WSCallUserDOB = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB : null;
        this.qdeService.professionalData = wsDetails1;
        this.qdeService.secondSectionData = Object.assign(
          {},
          wsDetails, wsDetails1
        );
        this.fetchName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName + ',' : '';

        if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType
          && (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation != 1 && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation != 2)) {
          this.firstStep = false;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 0), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType
          && (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode == 'P' || this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode == 'T')
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB
        ) {
          this.secondStep = true;
          this.firstStep = true;
          setTimeout(() => (this.stepper.selectedIndex = 2), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType
          && (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode != 'P' && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode !== 'T')
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode
        ) {
          this.secondStep = true;
          this.firstStep = true;
          setTimeout(() => (this.stepper.selectedIndex = 2), 1000);
        } else if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId
          && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserContactConsent
        ) {
          this.firstStep = true;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 1), 1000);
        } else {
          this.firstStep = false;
          this.secondStep = false;
          setTimeout(() => (this.stepper.selectedIndex = 0), 1000);
        }
      }


    }
  }

  callRetrieveFromPopup($event) {
    this.retrieveDataReceived = $event.data;
    this.sharedService.retrievedApplicationResponse = this.retrieveDataReceived;
    this.retrieveJourney();

  }

  numberOnly(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  setThemeByParam(theme) {
    this.themeParam = theme;
    console.log(this.themeParam);
    this.getThemeFromService(theme);
    this.themeService.themeParam = this.themeParam;
  }



  setName(event) {
    this.fetchName = event;
  }
  ngOnDestroy() {
    let form: any;
    let label: any;
    this.sharedService.analyticsFormAbandonObj.subscribe(data => {
      form = data.section,
        label = data.field
    })
    if (!this.sharedService.qdeSuccessResponse) {
      form_abandon(this.sharedService.cardName, form, label)
    }
  }
  callFormAbandon() {
    form_abandon(this.sharedService.cardName, '', '')
  }


  getThemeFromService(theme) {
    this.themeService.getThemeData(theme).subscribe((result: any) => {
      if (result) {
        if (result.partner_id && result.partner_id === theme) {
          this.responseTheme = result;
          this.themeObj = this.responseTheme;
          this.themeService.setThemePage(this.themeObj);
          cssVars({ variables: this.themeObj });//Theme change for IE 
        } else {
          // this.errorMsg = 'JSON not found';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({ variables: SBICARDTheme });//Theme change for IE 
        }
      } else {
        // this.errorMsg = 'JSON error';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({ variables: SBICARDTheme });//Theme change for IE 
      }
    },
      (error) => {
        // this.errorMsg = 'Service not available';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({ variables: SBICARDTheme });//Theme change for IE 
      }
    );
  }

}
